export const PROPOSALS_TO_SHOW = 10
export const ADMINS = [
  '0x842B508681eE336E74600974B4623B709477d29D', // TARO flame.eth
  '0x977e0c1005dff8749f8cac22f4df0bd5f013d1a7', // CHUNGUS flame.eth
  '0xa3D2124E4023ea5c74dC749012E0B46E42bDD648', // LIME flamevote.eth
  '0x4634fC1462B7974dB96B700E9aBe915f0884e60a', // GYOZA flamevote.eth
  '0xa7551aBe0A066555cb5d859849426fB55543Ca25', // MUSTARD flamevote.eth
].map((address) => address.toLowerCase())
export const IPFS_GATEWAY = 'https://gateway.ipfs.io/ipfs'
export const SNAPSHOT_VERSION = '0.1.3'
export const DONASWAP_SPACE = 'flamevote.eth'
export const VOTE_THRESHOLD = 10
